// removed by extract-text-webpack-plugin
module.exports = {"app-bar":"theme--app-bar--1Qjww3t_","appBar":"theme--app-bar--1Qjww3t_"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/AppBar/theme.scss
// module id = 1176
// module chunks = 0